<template>
  <UsuariosPage />
</template>

<script setup>
import UsuariosPage from "../pages/UsuariosPage.vue";
</script>
